/* eslint-disable react-hooks/exhaustive-deps */
import {KlassappTableProps, YesNo} from "types/common"
import styles from "./GeofencingSettings.module.css"
import {Col} from "antd"
import {BaseButton, BaseInput, BaseLoading} from "components"
import {useCallback, useEffect, useState} from "react"
import {useMutation} from "@tanstack/react-query"
import {useGeofencingSettings} from "hooks/useGeofencingSettings"
import {GeneralSettingField} from "types/settings/general-setting"
import {generalSettingsService} from "services"
import {handleError, toastSuccess} from "helpers"
import {useTranslation} from "react-i18next"

function GeofencingSettings(props: KlassappTableProps) {
    const geofencingSettings = useGeofencingSettings({
        enabled: true
    })
    const [geofencingRadiusInMeters, setGeofencingRadiusInMeters] = useState<string>(
        geofencingSettings.geofencingRadiusInMeters || ""
    )
    const {t} = useTranslation(["common"])

    useEffect(() => {
        setGeofencingRadiusInMeters(geofencingSettings.geofencingRadiusInMeters)
    }, [geofencingSettings.geofencingRadiusInMeters])

    const updateGeneralSettings = useMutation(
        async (payload: Array<{field: GeneralSettingField; checked: boolean | string}>) => {
            await generalSettingsService.updateSettings(
                payload.map(({field, checked}) => {
                    if (typeof checked === "boolean") {
                        return {
                            field,
                            value: checked ? YesNo.Yes : YesNo.No
                        }
                    }
                    return {
                        field,
                        value: checked
                    }
                })
            )
        },
        {
            onSuccess() {
                geofencingSettings.refetch()
            },
            onError: (err) => {
                handleError(err)
            }
        }
    )

    const onClickSave = useCallback(async () => {
        try {
            updateGeneralSettings.mutate([
                {
                    field: GeneralSettingField.GeofencingRadiusInMeters,
                    checked: geofencingRadiusInMeters
                }
            ])

            toastSuccess("Updated")
        } catch (error: any) {
            handleError(error)
        }
    }, [geofencingRadiusInMeters, updateGeneralSettings])

    const onClickCancelBtn = useCallback(() => {
        setGeofencingRadiusInMeters(geofencingSettings.geofencingRadiusInMeters)
    }, [geofencingSettings])

    const isChanged = geofencingRadiusInMeters !== geofencingSettings.geofencingRadiusInMeters

    return (
        <div className={styles.wrapper}>
            <span className={styles.title}>Radius</span>
            <Col span={24} className={styles.settingContainer}>
                <BaseInput
                    onChange={(text) => {
                        setGeofencingRadiusInMeters(text)
                    }}
                    placeholder={"Number"}
                    style={{width: 150}}
                    disabledArrow
                    type="number"
                    min={0}
                    value={geofencingRadiusInMeters}
                    suffix={<span style={{color: "grey"}}>Meter</span>}
                />
            </Col>

            <div className={styles.action}>
                <BaseButton
                    title={t("common:action.cancel")}
                    variant="secondary"
                    className={styles.cancelBtn}
                    disabled={!isChanged}
                    onClick={onClickCancelBtn}
                />
                <BaseButton
                    title={t("common:action.save")}
                    onClick={onClickSave}
                    disabled={!isChanged}
                    loading={updateGeneralSettings.isLoading}
                />
            </div>
            <BaseLoading isShow={geofencingSettings.isFetching} />
        </div>
    )
}

export default GeofencingSettings
